import PropTypes from "prop-types";
import useAppModernisation from "../../hooks/useAppModernisation";
import styles from "./SiteLayout.module.scss";

/**
 * SiteLayout - High-level layout wrapper that applies modernisation style classes site-wide
 */
const SiteLayout = ({ children, className = "" }) => {
  const { isWebModernisationEnabled } = useAppModernisation();

  const layoutClasses = [
    styles.siteLayout,
    isWebModernisationEnabled ? styles.siteModernised : styles.siteLegacy,
    isWebModernisationEnabled ? "modernisation-enabled" : "", // Add global class for fonts
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={layoutClasses}>{children}</div>;
};

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default SiteLayout;
